import { Directive, ElementRef, Inject, OnInit } from '@angular/core';
import { THEME_TOKEN, Theme } from '../../types/theme.types';
import { componentStylesByTheme } from '../../utils/theme.utils';
import { style } from '../../utils/style.utils';
import { tabsBaseStylesSAG, tabsBaseStylesSHS } from './tabs-base.styles';

@Directive({
  selector: '[sag-ui-tabs-base]',
})
export class TabsBaseDirective implements OnInit {
  constructor(
    @Inject(THEME_TOKEN) private readonly theme: Theme,
    private readonly elementRef: ElementRef<HTMLInputElement>
  ) {}

  ngOnInit(): void {
    const inputStyles = componentStylesByTheme(
      this.theme,
      tabsBaseStylesSAG,
      tabsBaseStylesSHS
    );
    style(this.elementRef, inputStyles());
  }
}
